import api from './api';

export default function deleteFromVIDAADB(id, uiNotificationService) {
  console.log('Delete fromVIDAA db, add to VIDAADB script');
  deleteMeasurement(id).then(result => {
    console.log('Delete measurement result', result);
     uiNotificationService.show({
        title: 'Measurement Deleted',
        message: `The measurement is deleted correctly.`,
        type: 'success',
        duration: 5000,
      });
  }). catch(error => {
     uiNotificationService.show({
        title: 'Error Deleting Measurement',
        message: `There was a problem deleting the measurement. ${error}`,
        type: 'error',
        autoClose: false,
      });
  }
  );
}

async function deleteMeasurement(id) {
  const path = `/annotations/image-annotation/${id}`;

  try {
    return await api.delete(path);
  } catch (error) {
    throw new Error(
      `${error.response?.status}: ${error.response?.statusText || error.message}`
    );
  }
}
